(ns manatee.admin.task-config.add.view
  "The admin. create task configuration form.
   Allows administrators and project owners to create new task configurations
   (this will also create the corresponding queue configuration)."
  (:require
   [manatee.admin.rejection-option.handlers :as admin-rejection-handlers]
   [manatee.admin.rejection-option.subs :as rejection-subs]
   [manatee.admin.subs :as subs]
   [manatee.admin.task-config.add.handlers :as handlers]
   [manatee.admin.task-config.form-components :as form-components]
   [manatee.admin.task-config.subs :as task-config-subs]
   [manatee.admin.task-config.view :as task-config-view]
   [manatee.admin.view :as admin-view]
   [manatee.components.notifications.container :as notifications]
   [manatee.domain.task :as task-domain]
   [manatee.ui.templates :as templates]
   [manatee.user.subs :as user-subs]
   [re-frame.core :as rf]
   [rothko.layout.component :refer [layout]]
   [rothko.panel.component :refer [panel]]))

(defn- create-task-button
  []
  {:button {:appearance #{:primary}
            :class [:task-page__submit-button]
            :id :submit-btn}
   :label "Create Task"})

(defn- add-task-form
  [{:keys [current-user users !uploaded-submissions] :as props}]
  (let [mods #(contains? #{:allow-reports-checkbox :allow-deferments-checkbox} %)
        project-owner? (= (:role current-user)
                          "project-owner")
        team-id (when project-owner?
                  (:team (first (filter #(= (str (:id %))
                                            (:id current-user))
                                        users))))
        form-values {:team-id team-id
                     :score-range {:from 0 :to 5}
                     :modifiers mods}]
    (task-config-view/task-form props
                                form-values
                                {:form-name :add-task-form
                                 :upload-button (form-components/upload-button-div !uploaded-submissions)
                                 :submit-button (create-task-button)
                                 :on-submit (fn [form-values reset-submitting-flag]
                                              (rf/dispatch [::handlers/add-task form-values @!uploaded-submissions reset-submitting-flag]))})))

(defn container
  [props]
  (let [admin? @(rf/subscribe [::user-subs/admin?])
        project-owner? @(rf/subscribe [::user-subs/project-owner?])
        current-user @(rf/subscribe [::user-subs/user])
        users @(rf/subscribe [::subs/users])
        user-teams @(rf/subscribe [::subs/user-teams])
        existing-task-names @(rf/subscribe [::task-config-subs/task-config-names])
        part-rejection-options-speech @(rf/subscribe [::rejection-subs/select-rejection-options :part :speech])
        part-rejection-options-text @(rf/subscribe [::rejection-subs/select-rejection-options :part :text])
        answer-rejection-options-speech @(rf/subscribe [::rejection-subs/select-rejection-options :answer :speech])
        answer-rejection-options-text @(rf/subscribe [::rejection-subs/select-rejection-options :answer :text])]
    (when (or admin? project-owner?)
      (rf/dispatch [::admin-rejection-handlers/load-rejection-options])) ; https://btsservice.atlassian.net/browse/ELIT-4706
    (if (or admin? project-owner?)
      [:<>
       [notifications/alerts {:banner-id :main
                              :max-alerts 1}]
       [panel {:appearance #{:primary}
               :class [:task-page__panel]}
        [layout {:appearance #{:column}
                 :class [:task-page__form-layout]}
         [:h2 "Create task"]
         [add-task-form (merge props {:sources task-domain/sources
                                      :project-owner? project-owner?
                                      :current-user current-user
                                      :users users
                                      :user-teams user-teams
                                      :part-score-types task-domain/part-score-types
                                      :answer-score-types task-domain/answer-score-types
                                      :types task-domain/types
                                      :!uploaded-submissions (atom nil)
                                      :part-rejection-options-speech part-rejection-options-speech
                                      :part-rejection-options-text part-rejection-options-text
                                      :answer-rejection-options-speech answer-rejection-options-speech
                                      :answer-rejection-options-text answer-rejection-options-text
                                      :existing-task-names (set existing-task-names)
                                      :existing-task? false})]]]]
      [admin-view/access-denied props])))

(def page
  {:main container
   :template templates/single-column})
